import { Component, OnInit } from '@angular/core';
import { DefectService } from 'src/app/workshop/services/defect.service';
import { Defect } from 'src/app/workshop/models/defect.model';
import { catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'app-open-vehicle-defects',
    templateUrl: './open-vehicle-defects.component.html',
    styleUrls: ['./open-vehicle-defects.component.scss'],
    standalone: false
})
export class OpenVehicleDefectsComponent implements OnInit {
  defects: Defect[] = [];
  loaded: boolean = false;

  constructor(private defectService: DefectService) { }

  ngOnInit(): void {
    this.defectService.getOpenDefectsForDashboard()
      .pipe(take(1))
      .pipe(catchError(() => of([])))
      .subscribe((defects) => {
        this.defects = defects;
        this.loaded = true;
      });
  }

}
